// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__kxZFg","disabled":"FileBtn_disabled__1m0OZ","warn":"FileBtn_warn__2CK7c","fade":"FileBtn_fade__3MF-R"};